<div class="search-container grey-border">
  <div class="ion-no-padding ion-padding-horizontal ion-padding-top">
    <!-- Custom Tab Selector -->
    <div class="custom-tab-container">
      <div class="tab-track" [class.return-active]="radioState === 'return'">
        <button 
          class="tab-button" 
          [class.active]="radioState === 'one_way'"
          (click)="onTabClick('one_way')"
        >
          {{ "flight.flights_search.one_way" | translate }}
        </button>
        <button 
          class="tab-button" 
          [class.active]="radioState === 'return'"
          (click)="onTabClick('return')"
        >
          {{ "flight.flights_search.return" | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- Radio Selector Row ENDS here -->

  <!-- FlexiCancel info banner shown below the One-way/Return tabs -->
  <div class="ion-padding-horizontal ion-padding-top" *ngIf="fareType === 'flexicancel'">
    <div class="flexi-info-banner d-flex ion-align-items-center">
      <img src="/assets/images/flight.png" alt="flight" class="flexi-info-icon" />
      <span class="flexi-info-text fs-1 font600">This feature is currently valid for Indian domestic routes.</span>
    </div>
  </div>

  <!--************************* ONE-WAY and RETURN Code STARTS here *************************-->
  <form [formGroup]="bookFlightSearchForm" class="pad6">
    <ng-template [ngIf]="radioState === 'one_way' || radioState === 'return'">
      <ion-grid>
        <ion-row class="select-airport">
          <ion-col size="6">
            <ion-item
              lines="none"
              class="field search"
              lines="none"
              (click)="getAirport('source', 0)"
            >
              <div
                class="d-flex ion-justify-content-between ion-align-items-center w100 height100"
              >
                <div class="align-label">
                  <ion-label position="stacked" class="fs-4 font400"
                    ><img
                      src="/assets/icons/planeoff.png"
                      class="label-icon"
                    /><span class="marl4">{{
                      "flight.flights_search.from" | translate
                    }}</span></ion-label
                  >
                  <ion-label
                    class="ion-no-padding ion-padding-top"
                    [ngClass]="
                      flightQueryFields[0].Origin
                        ? 'fs-3 font500 black-text '
                        : 'fs-3 font400 gray-text'
                    "
                  >
                    {{
                      flightQueryFields[0].Origin ||
                        ("flight.flights_search.source" | translate)
                    }}
                  </ion-label>
                </div>
              </div>
            </ion-item>
            <div
              *ngIf="
                bookFlightSearchForm.get('source-0')?.invalid &&
                (bookFlightSearchForm.get('source-0').dirty ||
                  bookFlightSearchForm.get('source-0').touched)
              "
            >
              <div
                *ngIf="bookFlightSearchForm.get('source-0')?.errors?.required"
                class="validation-error"
              >
                {{ "flight.flights_search.source_is_required" | translate }}
              </div>
            </div>
          </ion-col>
          <custom-icon
            class="two-flights-icon"
            iconName="TWO_FLIGHT_ICON"
            [width]="22"
            [height]="22"
            (click)="switchSourceDestination()"
          ></custom-icon>
          <ion-col size="6">
            <ion-item
              lines="none"
              class="field search"
              lines="none"
              (click)="getAirport('destination', 0)"
            >
              <div
                class="d-flex ion-justify-content-between ion-align-items-center w100 height100"
              >
                <div class="align-label">
                  <ion-label position="stacked" class="fs-4 font400"
                    ><img
                      src="/assets/icons/planeland.png"
                      class="label-icon"
                    /><span class="marl4">{{
                      "flight.flights_search.to" | translate
                    }}</span></ion-label
                  >
                  <ion-label
                    class="ion-no-padding ion-padding-top"
                    [ngClass]="
                      flightQueryFields[0].Destination
                        ? 'fs-3 font500 black-text '
                        : 'fs-3 font400 gray-text'
                    "
                  >
                    {{
                      flightQueryFields[0].Destination ||
                        ("flight.flights_search.destination" | translate)
                    }}
                  </ion-label>
                </div>
              </div>
            </ion-item>
            <div
              *ngIf="
                bookFlightSearchForm.get('destination-0')?.invalid &&
                (bookFlightSearchForm.get('destination-0').dirty ||
                  bookFlightSearchForm.get('destination-0').touched)
              "
            >
              <div
                *ngIf="
                  bookFlightSearchForm.get('destination-0').errors.required
                "
                class="validation-error"
              >
                {{
                  "flight.flights_search.destination_is_required" | translate
                }}
              </div>
            </div>
            <div *ngIf="isSourceDestinationSame(0)" class="validation-error">
              {{
                "flight.flights_search.from_To_airports_cannot_be_the_same"
                  | translate
              }}
            </div>
          </ion-col>
        </ion-row>
        <!-- Date selection row STARTS here -->
        <ion-row>
          <ion-col size="6">
            <ion-item lines="none" class="field ion-no-padding">
              <ion-label
                position="stacked"
                class="fs-4 font400 ion-padding-start"
                ><img
                  src="/assets/icons/calendar.png"
                  class="label-icon"
                /><span class="marl4">{{
                  "flight.flights_search.departure" | translate
                }}</span></ion-label
              >
              <ion-input
                formControlName="departureDate-0"
                type="date"
                [min]="todayDate"
                max="9999-12-31"
                name="departure_date"
                [(ngModel)]="flightQueryFields?.[0].PreferredDepartureTime"
                placeholder="{{ 'flight.flights_search.date' | translate }}"
                aria-label="date"
                class="fs-2 font500 marl4 date"
                (ionChange)="handleReturnDate()"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="
                bookFlightSearchForm.get('departureDate-0')?.invalid &&
                (bookFlightSearchForm.get('departureDate-0').dirty ||
                  bookFlightSearchForm.get('departureDate-0').touched)
              "
            >
              <div
                *ngIf="
                  bookFlightSearchForm.get('departureDate-0').errors.required
                "
                class="validation-error"
              >
                {{
                  "flight.flights_search.departure_date_is_required" | translate
                }}
              </div>
            </div>
          </ion-col>
          <ion-col size="6">
            <ion-item
              lines="none"
              class="field ion-no-padding"
              [disabled]="radioState === 'one_way' ? true : false"
            >
              <ion-label
                position="stacked"
                class="fs-4 font400 ion-padding-start"
                ><img
                  src="/assets/icons/calendar.png"
                  class="label-icon"
                /><span class="marl4">{{
                  "flight.flights_search.add_return" | translate
                }}</span></ion-label
              >
              <ion-input
                formControlName="returnDate"
                type="date"
                [min]="flightQueryFields?.[0].PreferredDepartureTime || todayDate"
                max="9999-12-31"
                name="departure_date"
                [(ngModel)]="flightQueryFields?.[1].PreferredDepartureTime"
                placeholder="{{ 'flight.flights_search.date' | translate }}"
                aria-label="departure_date"
                class="fs-2 font500 marl4 date"
              ></ion-input>
            </ion-item>
            <div
              *ngIf="
                bookFlightSearchForm.get('returnDate')?.invalid &&
                (bookFlightSearchForm.get('returnDate').dirty ||
                  bookFlightSearchForm.get('returnDate').touched)
              "
            >
              <div
                *ngIf="bookFlightSearchForm.get('returnDate').errors.required"
                class="validation-error"
              >
                {{
                  "flight.flights_search.return_date_is_required" | translate
                }}
              </div>
            </div>
          </ion-col>
        </ion-row>
        <!-- Date selection row ENDS here -->

        <!-- Traveller Count code STARTS here  -->
        <ion-row>
          <ion-col>
            <ion-item lines="none" class="field" id="passenger-count-modal">
              <div>
                <ion-label position="stacked" class="fs-4 font400"
                  ><img
                    src="/assets/icons/people.png"
                    class="label-icon"
                  /><span class="marl4"
                    >{{ "flight.flights_search.traveller" | translate }} and
                    Class</span
                  ></ion-label
                >
              </div>
              <div
                class="d-flex w100 ion-justify-content-between ion-align-items-center"
              >
                <ion-input
                  [readonly]="true"
                  formControlName="travellerCount"
                  class="custom ion-no-padding fs-3 font500"
                  aria-label="travellerCount"
                >
                </ion-input>
              </div>
            </ion-item>
            <div
              *ngIf="
                bookFlightSearchForm.get('travellerCount')?.invalid &&
                (bookFlightSearchForm.get('travellerCount').dirty ||
                  bookFlightSearchForm.get('travellerCount').touched)
              "
            >
              <div
                *ngIf="
                  bookFlightSearchForm.get('travellerCount').errors.required
                "
                class="validation-error"
              >
                {{ "flight.flights_search.atleast_one_traveller" | translate }}
              </div>
            </div>
          </ion-col>
        </ion-row>
        <passenger-count-modal
          (getPassengerData)="passengerDataHandler($event)"
          [passengerData]="passenger"
          [fareType]="fareType"
        ></passenger-count-modal>
        <!-- Traveller Count code ENDS here  -->

        <!-- Travel Class code STARTS here  -->
        <!-- <ion-row>
            <ion-col>
              <ion-item lines="none" class="field">
                <ion-label position="stacked" class="fs-4 font400"
                  ><img
                    src="/assets/icons/people.png"
                    class="label-icon"
                  /><span class="marl4"
                    >{{"flight.flights_search.travel_class" | translate}}</span
                  ></ion-label
                >
                <ion-select
                  formControlName="travelClass"
                  interface="popover"
                  (ionChange)="handleTravelClassSelection($event)"
                  class="fs-3 font500"
                >
                  <ion-select-option value="AllClass"
                    >{{"flight.flights_search.all_class" |
                    translate}}</ion-select-option
                  >
                  <ion-select-option value="Economy"
                    >{{"flight.flights_search.economy" |
                    translate}}</ion-select-option
                  >
                  <ion-select-option value="PremiumEconomy"
                    >{{"flight.flights_search.premium_economy" |
                    translate}}</ion-select-option
                  >
                  <ion-select-option value="Business"
                    >{{"flight.flights_search.business" |
                    translate}}</ion-select-option
                  >
                  <ion-select-option value="PremiumBusiness"
                    >{{"flight.flights_search.premium_business" |
                    translate}}</ion-select-option
                  >
                  <ion-select-option value="First"
                    >{{"flight.flights_search.first" |
                    translate}}</ion-select-option
                  >
                </ion-select>
              </ion-item>
            </ion-col>
          </ion-row> -->
        <!-- Travel Class code ENDS here  -->

        <!-- Airline preference code STARTS here  -->
        <!-- <ion-row>
          <ion-col>
            <ion-item class="field" lines="none" (click)="getAirlines()">
              <ion-label position="stacked"
                >{{"flight.flights_search.airline_preference" |
                translate}}</ion-label
              >
              <div
                class="d-flex w100 ion-justify-content-between ion-align-items-center"
              >
                <ion-input
                  [readonly]="true"
                  class="custom ion-no-padding fs-3 font500"
                  aria-label="airlineText"
                  value="{{airlineText}}"
                >
                </ion-input>
                <ion-icon
                  name="chevron-down-outline"
                  class="primary-icon-color"
                  slot="end"
                ></ion-icon>
              </div>
            </ion-item>
          </ion-col>
        </ion-row> -->
        <!-- Airline preference code ENDS here  -->
      </ion-grid>
    </ng-template>

    <!--************************* ONE-WAY and RETURN Code ENDS here *************************-->
  </form>
  
  <ion-button
    class="primary-btn ion-no-margin ion-margin-horizontal fs-3 padb10"
    expand="block"
    mode="ios"
    [disabled]="bookFlightSearchForm.invalid || sourceDestinationSameError || isSearchDisabled"
    (click)="handleBooking()"
  >
    {{ "flight.flights_search.search_flight" | translate }}
  </ion-button>
</div>
